import VSlider from './VSlider'

export { VSlider }
export default VSlider
